<template>
  <v-container
    fluid
    fill-height
    no-gutters
  >
    <v-row fill-height>
      <v-col>
        <v-row class="justify-center">
          <v-col cols="auto">
            <v-subheader class="display-4 font-weight-bold">404</v-subheader>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="auto">
            <v-subheader class="display-2">{{$i18n.t('default.pageNotFound')}}</v-subheader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style lang="scss" scoped>
</style>